<template>
  <div class="timeout">
    <div class="timeout-logo">
      <img src="@/assets/images/timeout.png" />
    </div>
    <div class="timeout-content">
      <p>{{ title }}</p>
      <p>{{ content }}</p>
    </div>
    <div class="timeout-button">
      <Button @click="handleClick">{{ buttonText }}</Button>
    </div>
  </div>
</template>
    
  <script lang="ts">
import { defineComponent } from "@vue/composition-api";
import { Button } from "mand-mobile";
import { useI18n } from "@/utils/register/i18n";

export default defineComponent({
  name: "market-timeout",
  components: {
    Button,
  },
  setup() {
    const title = useI18n().t("Fintech_Credit_Test_DsTs_pLrP");
    const content = useI18n().t("Fintech_Credit_Test_ZNEn_jvup");
    const buttonText = useI18n().t("Fintech_Credit_Test_EsjO_kiHK");

    const handleClick = () => {
      window.location.reload();
    };
    return {
      title,
      content,
      buttonText,
      handleClick,
    };
  },
});
</script>
    
  <style scoped>
.timeout-logo {
  display: flex;
  justify-content: center;
  margin-top: 62px;
}
.timeout-logo img{
  width: 150px;
  height: 136px;
}
.timeout-content {
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-top: 110px;
  font-family: DiDiSans-Pro-Regular;
  font-size: 46px;
  font-weight: 400;
  color: #4a4a4a;
  letter-spacing: 0;
  text-align: center;
}
.timeout-content p:first-child {
  margin-bottom: 50px;
}
.timeout-button {
  display: flex;
  justify-content: center;
  margin-top: 192px;
}
.timeout-button button {
  width: 618px;
  height: 86px;
  background-image: linear-gradient(86deg, #ff5c1e 0%, #fe7f3e 96%);
  border-radius: 9.97px;
  border: #ffffff;
  font-family: DiDiSans-Pro-Regular;
  font-size: 30px;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
}
>>> .md-button.default:after {
  border: #ffffff !important;
}
.timeout-button button:active,
.timeout-button button:focus {
  background: linear-gradient(86deg, #ff5c1e 0%, #fe7f3e 96%) !important;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.5);
}
</style>
    
  